import React from 'react';
import CardDetailsComponent from './card-details.component';

function CardDetails(props) {
    return <CardDetailsComponent {...props} />;
}

export default CardDetails;
